import { useState } from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const QUICK_FAQ = [
  {
    q: "Combien coûte cette première étude ?",
    a: "C'est entièrement gratuit et sans engagement. Vous recevez sous 24 h une simulation chiffrée de revenus + un plan d'optimisation, peu importe que vous décidiez ou non de travailler avec nous.",
  },
  {
    q: "Sous combien de temps ai-je une réponse ?",
    a: "Nous nous engageons à vous rappeler sous 24 h ouvrées (du lundi au samedi). Si vous appelez directement au 02 55 99 66 25, vous nous avez en général sous 5 minutes.",
  },
  {
    q: "Mon bien doit-il déjà être prêt à louer ?",
    a: "Non. Nous travaillons aussi avec des biens en cours d'aménagement, en travaux ou que vous venez d'acheter. Notre forfait équipement clé-en-main (à partir de 890 € TTC) prend tout en charge.",
  },
  {
    q: "Que se passe-t-il si je ne suis pas convaincu ?",
    a: "Aucun engagement, aucun frais. Vous repartez avec une étude personnalisée que vous pouvez utiliser comme bon vous semble. Notre objectif est de bâtir une relation longue, pas de signer à tout prix.",
  },
];

const ContactQuickFAQ = () => (
  <section
    className="py-16 lg:py-20 bg-sand"
    data-testid="contact-quick-faq"
  >
    <div className="container-tm">
      <div className="grid lg:grid-cols-12 gap-10 mb-10 items-end">
        <div className="lg:col-span-7">
          <p className="overline mb-3">Avant de nous contacter</p>
          <h2 className="font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
            Les <em className="text-gold">4 questions</em> que tout le monde
            nous pose.
          </h2>
        </div>
      </div>

      <div className="max-w-3xl">
        <Accordion type="single" collapsible className="w-full">
          {QUICK_FAQ.map((item, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`quick-faq-item-${i}`}
              className="border-b border-ink/10 first:border-t"
            >
              <AccordionTrigger className="text-left font-serif text-lg md:text-xl text-ink hover:text-gold py-5 hover:no-underline">
                <span className="flex items-start gap-4 pr-4">
                  <span className="font-serif italic text-gold/70 text-base font-light shrink-0 mt-1">
                    0{i + 1}
                  </span>
                  <span>{item.q}</span>
                </span>
              </AccordionTrigger>
              <AccordionContent className="font-sans text-base text-ink/70 leading-relaxed pb-6 pl-10">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default ContactQuickFAQ;
